var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"liquidFill",staticStyle:{"width":"120px","height":"120px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }